$(document).ready(function () {
	document.documentElement.className = 'js-enabled';
	$('#boxinv-form').parsley();
	hide_button()
	var products = $('input[name^=product').change(function (event) {
		var total = products.map(function () {
			return $(this).val()
		}).get()
		var added = 0
		total.forEach(element => {
			added += parseInt(element)
		});
		if (added >= 20) {
			show_button()
		} else {
			hide_button()
		}
	});
	console.log(products);
	$("#boxinv-form input[name='boxinv-name']").on('change', function () {
		name = $(this).val();
		$('.script_host_name').html(name);
	});
	$("input[name='boxinv-reason']").on('change', function () {
		org = $(this).val();
		$('.script_org_name').html(org);
	});
	$('.script_host_name')
	$('.script_org_name')

	function hide_button() {
		$('#boxinv-button').hide();
		$('#boxinv-quantity-error').show();
	}

	function show_button() {
		$('#boxinv-button').show();
		$('#boxinv-quantity-error').hide();
	}
});
